import React from 'react';

import IncidentEventSelect from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IncidentEventSelect';
import IncidentUrgencySelect from 'src/views/Admin/Modals/EditRuleModal/RuleForm/components/IncidentUrgencySelect';
import Field from 'src/views/components/Form/Field';
import { PdPrioritySelect } from 'src/views/components/select';

const PagerDutyConditionSelector = ({ name, values = {}, touched = {}, errors = {}, onChange, onBlur, incidentEventOptions }) => {
  return (
    <div style={{ paddingBottom: 10 }}>
      <Field errorMessage={touched.pd_events && errors.pd_events}>
        <IncidentEventSelect
          name={`${name}.pd_events`}
          value={values.pd_events}
          options={incidentEventOptions}
          onChange={onChange}
          onBlur={onBlur}
          isMulti
        />
      </Field>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '50%', textAlign: 'right', padding: '1rem 1rem 0 0' }}>AND priority is one of: </div>
        <div style={{ width: '50%' }}>
          <Field errorMessage={touched.pd_priorities && errors.pd_priorities}>
            <PdPrioritySelect
              placeholder="Any"
              name={`${name}.pd_priorities`}
              value={values.pd_priorities}
              onChange={onChange}
              onBlur={onBlur}
              isMulti
            />
          </Field>
        </div>
      </div>

      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <div style={{ width: '50%', textAlign: 'right', padding: '1rem 1rem 0 0' }}>AND urgency is: </div>
        <div style={{ width: '50%' }}>
          <Field errorMessage={touched.pd_urgency && errors.pd_urgency}>
            <IncidentUrgencySelect
              isClearable
              placeholder="Any"
              name={`${name}.pd_urgency`}
              value={values.pd_urgency}
              onChange={onChange}
              onBlur={onBlur}
            />
          </Field>
        </div>
      </div>
    </div>
  );
};

export default PagerDutyConditionSelector;
